import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stat: null,
  file: null,
  title: '',
  preview: null,
  uploaded: null,
  loading: false,
};

const imgSplitSlice = createSlice({
  name: "imgSplit",
  initialState,
  reducers: {
    setStat: (state, action) => {
      state.stat = action.payload;
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setPreview: (state, action) => {
      state.preview = action.payload;
    },
    setUploaded: (state, action) => {
      state.uploaded = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setStat,
  setFile,
  setTitle,
  setPreview,
  setUploaded,
  setLoading,
  reset,
} = imgSplitSlice.actions;

export default imgSplitSlice.reducer;
